// extracted by mini-css-extract-plugin
export var icon = "_bd-3";
export var subtitle = "_bd-2";
export var title = "_bd-1";
export var value = "_bd-0";